// extracted by mini-css-extract-plugin
export default {"DialogContent":"styles_DialogContent__aZIrQ"};